import axios from "axios";
import config from "./config";

const env = process.env.NODE_ENV || "development";
const stage = config[env];
const API_URL = stage.base_url + "/social/";

const addSocial = (handle, platform, jwt, fromReview = false) => {
  const headers = { Authorization: "bearer " + jwt };
  return axios.post(
    API_URL + "create",
    { handle, platform, fromReview },
    { headers: headers }
  );
};

const fetchAllWithUserID = (userID) => {
  return axios.get(API_URL + `all/${userID}`);
};

const fetch = (handle, platform) => {
  // const headers = { Authorization: "bearer " + jwt };
  return axios.get(API_URL + `?handle=${handle}&platform=${platform}`);
};

// const getCurrentUser = () => {
//   return JSON.parse(localStorage.getItem("user"));
// };

export default {
  addSocial,
  fetch,
  fetchAllWithUserID,
};
